import React from "react";

interface NavigationButtonsProps {
  onBack?: () => void;
  onNext?: () => void;
  floatNext?: boolean;
  nextDisabled?: boolean;
  nextTransparent?: boolean;
  nextLabel?: string;
  backLabel?: string;
  totalAmount?: number;
  totalTip?: string;
  showTotal?: boolean;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  onBack,
  onNext,
  nextDisabled = false,
  floatNext = false,
  nextTransparent = false,
  nextLabel = "ПРОДОЛЖИТЬ",
  backLabel = "НАЗАД",
  totalAmount,
  totalTip = "",
  showTotal = false
}) => {
  return (
    <>
      <div className="flex gap-5 w-full justify-between max-sm:flex-col items-center pb-5">
        {onBack && (
          <button
            className="flex gap-2 items-center px-5 py-4 text-xs bg-gray-200 cursor-pointer border-[none] text-[black] max-sm:justify-center max-sm:w-full"
            onClick={onBack}
          >
            <div
              className="ml-2.5 w-2.5 h-2.5 border-l-2 border-b-2 border-solid transition-transform border-l-black border-b-black rotate-45"
            />
            <span className="text-black mr-2.5">{backLabel}</span>
          </button>
        )}
        <div  className="grow" />
        {showTotal && totalAmount !== undefined && (
          <div className="text-sm font-medium">
            <span>{totalTip} </span>
            {totalTip == "" && (
              <>
                <span>Итого: </span>
                <span className="text-amber-500">
                  <span>{totalAmount}</span>
                  <span> ₽</span>
                </span>
              </>
            )}
          </div>
        )}

        {onNext && floatNext && (
          <button
            className="flex gap-2 items-center px-8 py-4 text-xs bg-black cursor-pointer border-[none] text-[white] max-sm:hidden max-sm:justify-center max-sm:w-full"
            onClick={onNext}
            disabled={totalTip != "" || nextDisabled}
            style={{
              opacity: (totalTip != "" || nextDisabled || nextTransparent) ? "0.5" : "1",
            }}
          >
            <span className="text-white">{nextLabel}</span>
            <div className="bg-amber-500 rounded h-[5px] w-[5px]" />
          </button>
        )}

        {onNext && !floatNext && (
          <button
            className="flex gap-2 items-center px-8 py-4 text-xs bg-black cursor-pointer border-[none] text-[white] max-sm:justify-center max-sm:w-full"
            onClick={onNext}
            disabled={totalTip != "" || nextDisabled}
            style={{
              opacity: (totalTip != "" || nextDisabled || nextTransparent) ? "0.5" : "1",
            }}
          >
            <span className="text-white">{nextLabel}</span>
            <div className="bg-amber-500 rounded h-[5px] w-[5px]" />
          </button>
        )}
      </div>
      {onNext && floatNext && (
        <button
          className="hidden gap-2 items-center px-8 py-4 text-xs bg-black cursor-pointer border-[none] text-[white] max-sm:flex max-sm:justify-center max-sm:w-full max-sm:sticky max-sm:bottom-2"
          onClick={onNext}
          disabled={totalTip != "" || nextDisabled}
          style={{
            opacity: (totalTip != "" || nextDisabled || nextTransparent) ? "0.5" : "1",
          }}
        >
          <span className="text-white">{nextLabel}</span>
          <div className="bg-amber-500 rounded h-[5px] w-[5px]" />
        </button>
      )}
    </>
  );
};
